// utils/socketManager.ts
import { Push } from '@/utils/push-vue'

type EventCallback = (data?: any) => void

class SocketManager {
    public socket: Push | null = null
    private connected: boolean = false
    private connectPromise: Promise<void> | null = null
    private resolveConnect: (() => void) | null = null
    private subscribers: { event: string; callback: EventCallback }[] = []

    /** 初始化并连接 WebSocket，返回一个 Promise 等待连接完成 */
    connect(): Promise<void> {
        if (this.connected) {
            return Promise.resolve()
        }

        if (this.connectPromise) {
            return this.connectPromise
        }

        this.connectPromise = new Promise((resolve) => {
            this.resolveConnect = resolve

            if (!this.socket) {
                this.socket = new Push({
                    url: 'wss://wss.mydoso.com',
                    app_key: 'aba42a158e0faa7c8972e1340652e312',
                    auth: 'https://api.mydoso.com/plugin/webman/push/auth',
                    onOpen: () => {
                        console.log('✅ WebSocket 已连接')
                        this.connected = true
                        // 通知 onOpen 等待的 Promise
                        this.resolveConnect && this.resolveConnect()
                        this.resolveConnect = null
                        this.connectPromise = null
                        // 通知所有订阅 open 事件的回调
                        this.notifySubscribers('open')
                    },
                    onClose: () => {
                        console.warn('❌ WebSocket 已关闭，5 秒后重连')
                        this.connected = false
                        setTimeout(() => this.connect(), 5000)
                    },
                    onError: (err) => {
                        console.error('⚠️ WebSocket 出错:', err)
                    },
                    onMessage: (msg) => {
                        this.notifySubscribers('message', msg)
                    }
                })
            }
        })

        return this.connectPromise
    }

    /** 发送数据 */
    send(data: any) {
        if (this.socket && this.connected) {
            this.socket.send(JSON.stringify(data))
        } else {
            console.warn('🚫 WebSocket 未连接')
        }
    }

    /** 注册事件回调 */
    on(event: 'open' | 'message', callback: EventCallback) {
        this.subscribers.push({ event, callback })
    }

    /** 内部调用，通知订阅者 */
    private notifySubscribers(event: 'open' | 'message', data?: any) {
        this.subscribers.forEach((s) => {
            if (s.event === event) s.callback(data)
        })
    }
}

// 全局单例
const socketManager = new SocketManager()
export default socketManager
